import React, { Dispatch, SetStateAction } from 'react';

// Styles
import './WpToggleButtonGroup.scss';

type Dispatcher<S> = Dispatch<SetStateAction<S>>;

export interface Props {
  children: React.ReactNode[];
  onTabClick: Dispatcher<string>;
  activeTab: string;
}

const WpToggleButtonGroup: React.FC<Props> = ({ onTabClick, activeTab, children }: Props) => {
  const handleTabClick = tab => {
    if (onTabClick) onTabClick(tab);
  };

  const newProps = {
    activeTab,
    onTabClick: handleTabClick,
  };

  const baseClassName = 'WpToggleButtonGroup';

  return (
    <div className={baseClassName}>
      {React.Children.map(children, (child: React.ReactElement<any>) => {
        if (!child) {
          return null;
        }
        return React.cloneElement(child, newProps);
      })}
    </div>
  );
};

export default WpToggleButtonGroup;
